export const routes = (prefix = `billing`, pref = `consultant-dashboard`) => [
    {
        path: `/${prefix}/${pref}/define-payment`,
        name: `${prefix}.${pref}.define-payment.create`,
        component: () => import('./Form.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pref}.define-payment.create`,
                PageDescription: "Consultant Payment: Define Payment",
            },
        },
    },
];
